import { FC, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { Button, Typography } from 'antd'
import { WarningOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { sensorStore } from '../store/sensor'
import { carrierStore } from '../store/carrier'

const { Title, Text } = Typography

interface NetworkPanelAlertProps {
	carrierId: number
}

const NetworkPanelAlert: FC<NetworkPanelAlertProps> = ({
	carrierId
}) => {
	const { t } = useTranslation()
	const { sensors } = sensorStore()
	const { carriers } = carrierStore()
	const [dismissed, setDismissed] = useState(false)

	const carrier = carriers.find((c) => c.id === carrierId)
	const isAffected = sensors.some(
		(s) =>
			s.code === 'side_netw_pult' &&
			s.sensorData[0]?.value === '1' &&
			s.sensorData[0]?.carrierId === carrierId
	)

	useEffect(() => {
		setDismissed(false)
	}, [carrierId])

	if (!isAffected || dismissed) return null

	return createPortal(
		<div
			style={{
				position: 'fixed',
				inset: 0,
				zIndex: 9999,
				background: 'var(--red)',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				gap: 20,
				padding: 32
			}}>
			<WarningOutlined
				style={{ fontSize: 96, color: '#fff' }}
			/>
			<Title
				level={1}
				style={{
					color: '#fff',
					margin: 0,
					textAlign: 'center'
				}}>
				{t('NetworkPanelAlertTitle')}
			</Title>
			<Text
				style={{
					color: '#ffe0e0',
					fontSize: 18,
					textAlign: 'center',
					maxWidth: 600
				}}>
				{t('NetworkPanelAlertBody')}
			</Text>
			<div
				style={{
					marginTop: 8,
					display: 'flex',
					flexDirection: 'column',
					gap: 8,
					alignItems: 'center'
				}}>
				<Text
					style={{
						color: '#fff',
						fontSize: 24,
						fontWeight: 700
					}}>
					{carrier?.name}
				</Text>
			</div>
			<Button
				size="large"
				type="primary"
				danger
				onClick={() => setDismissed(true)}
				style={{
					marginTop: 32,
					minWidth: 220,
					height: 48,
					fontSize: 16,
					background: '#fff',
					color: '#b30000',
					borderColor: '#fff'
				}}>
				{t('Acknowledge')}
			</Button>
		</div>,
		document.body
	)
}

export default NetworkPanelAlert
